import { transport } from 'config/transport';

export function callApiDeleteStudent(classId, studentId) {
    return transport.del(`/mamnon/classes/${classId}/students/${studentId}`);
}
